import { instance } from '@/api/instances'
import { ITEM_STATUS } from '@/models/secondOpinion'

const getAssignedToLoggedStaffPendingQuestions = async store => {
  const response = await getQuestions(
    `assigned_to_me=true&type=${ITEM_STATUS.ASSIGNED}`
  )
  const json = await response.data
  store.commit('setAssignedToLoggedStaffQuestions', json)
}

const getRequested = async (_, range) => {
  let filters = `type=${ITEM_STATUS.REQUESTED}`
  if (range) {
    const [startPage, endPage] = range
    filters = `${filters}&range=[${startPage},${endPage}]&sort=[0, ASC]`
  }
  const response = await getQuestions(filters)

  const itemsAmount = Number(
    response.headers.get('content-range') || response.length
  )
  const json = await response.data

  return { json, itemsAmount }
}

const getReadOnly = async (_, range) => {
  let filters = `type=${ITEM_STATUS.RESPONDED}&type=${ITEM_STATUS.ASSIGNED}&type=${ITEM_STATUS.CONCLUDED}`
  if (range) {
    const [startPage, endPage] = range
    filters = `${filters}&range=[${startPage},${endPage}]&sort=[0, DESC]`
  }
  const response = await getQuestions(filters)

  const itemsAmount = Number(
    response.headers.get('content-range') || response.length
  )
  const json = await response.data

  return { json, itemsAmount }
}

const getQuestions = filters => {
  return instance.getResponse(`specialist_opinion?${filters}`)
}

const getDetailedSecondOpinion = async (_, id) => {
  return await instance.get(`specialist_opinion/${id}`)
}

const assignQuestion = async (_, id) => {
  return (await instance.put(`specialist_opinion/${id}`))?.status
}

const answerQuestion = (_, { id, message, followUpWith }) => {
  const body = {
    message,
    followUpWith
  }

  return instance.post(`specialist_opinion/${id}`, {
    json: body
  })
}

const fetchSpecialties = async () => {
  const response = await instance.get(
    `specialist_opinion/available_specialties`
  )
  const json = await response
  return json
}

const getTimelineQuestions = async (_, ids) => {
  let params = ''

  ids.forEach((id, index, array) => {
    params = `${params}id=${id}`
    if (index !== array.length - 1) {
      params = `${params}&`
    }
  })

  return await instance.get(`specialist_opinion/find_by_ids?${params}`)
}

const resetState = store => store.commit('cleanState')

export default {
  getRequested,
  getReadOnly,
  getDetailedSecondOpinion,
  getAssignedToLoggedStaffPendingQuestions,
  assignQuestion,
  answerQuestion,
  fetchSpecialties,
  resetState,
  getTimelineQuestions
}
